import { FILTER_PRODUCTS } from './../const';

export default (filteredItems) => {
    return { type: FILTER_PRODUCTS, filteredItems }
};
